module.exports = __webpack_public_path__ + "img/LinkRoom.756d4a8d.jpg";